import { render } from "./AccessRole.vue?vue&type=template&id=7107539e&scoped=true"
import script from "./AccessRole.vue?vue&type=script&lang=js"
export * from "./AccessRole.vue?vue&type=script&lang=js"

import "./AccessRole.vue?vue&type=style&index=0&id=7107539e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7107539e"]])

export default __exports__